import styled from "styled-components";
import { hexToRgba } from "../../../themes/colorUtils";

export const Nav = styled.div`
  position: sticky;
  top: 0;
  z-index: 25;
  background: ${(p) => hexToRgba(p.theme.tokens.colors.bg, 0.94)};
  backdrop-filter: blur(10px);
  padding: 11px 0 10px;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const SearchRow = styled.div`
  padding: 0 14px 10px;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.md}px;
  padding: 10px 13px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.ink};
  background: none;
  min-width: 0;
`;

export const ClearButton = styled.button`
  border: none;
  background: ${(p) => p.theme.tokens.colors.softBg};
  border-radius: 999px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const ChipsRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 0 14px;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px 8px 11px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  font-family: ${(p) => p.theme.tokens.font.family};
  background: ${(p) => (p.$active ? p.theme.tokens.gradients.button : p.theme.tokens.colors.surface)};
  color: ${(p) => (p.$active ? p.theme.tokens.colors.surface : "#41524D")};
  box-shadow: ${(p) => (p.$active ? "0 6px 14px rgba(14,122,102,0.28)" : "0 1px 4px rgba(16,32,27,0.05)")};
  transition: all 0.15s;
`;

export const ChipIconBadge = styled.span<{ $active: boolean }>`
  display: inline-flex;
  width: 22px;
  height: 22px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background: ${(p) => (p.$active ? "rgba(255, 255, 255, 0.22)" : p.theme.tokens.colors.softTeal)};
  color: ${(p) => (p.$active ? p.theme.tokens.colors.surface : p.theme.tokens.colors.teal)};
`;
